import React from 'react';
import PropTypes from 'prop-types';
import { isType, flattenChildren } from '../../../../utils/react-children-utils/react-children-utils';
import ControlP from '../../../atoms/control/ControlP';
import { getValidationSummary, initFieldIsValids } from '../../../../utils/form-utils';
import SubmitForm from '../../../molecules/submit-form/index.ts';

class AccountSignupForm extends React.Component {
    constructor(props) {
        super(props);

        this.getControl = this.getControl.bind(this);
        this.setFieldState = this.setFieldState.bind(this);
        this.validateIsCharity = this.validateIsCharity.bind(this);

        // revalidate the form with any prefilled iputs
        const formControls = flattenChildren(props.children)
            .filter((child) => isType(child, 'ControlP'));

        // we only want controls that contain an Inputcontainer element.
        const prefillableControls = formControls
            .filter((child) => !flattenChildren(child.props.children)
                .find((i) => isType(i, 'InputContainer') && (i.props.name === 'ischarity')));

        const fieldIsValids = initFieldIsValids(prefillableControls);

        this.state = {
            fieldIsValids,
        };
    }

    getControl(control) {
        // Children of the ControlP and not this component.
        const controlChildren = flattenChildren(control.props.children);

        const inputContainer = controlChildren.find((c) => isType(c, 'InputContainer'));
        const label = inputContainer.props.name !== 'ischarity'
            ? controlChildren.find((c) => isType(c, 'InputLabel'))
            : undefined;

        const { required } = inputContainer.props;

        const passerror = inputContainer.props.name === 'ischarity' ? undefined : this.setFieldState;
        const validation = inputContainer.props.name === 'ischarity' ? this.validateIsCharity : undefined;

        const newContainer = React.cloneElement(
            inputContainer,
            {
                passerror,
                validation,
                required,
            },
        );

        return (
            <ControlP key={`${inputContainer.props.name}-control`}>
                {label}
                {newContainer}
            </ControlP>
        );
    }

    setFieldState(name, error) {
        const { fieldIsValids } = this.state;

        const newFields = fieldIsValids;
        newFields[name] = !error;

        this.setState(() => ({
            fieldIsValids: newFields,
        }));
    }

    validateIsCharity(event) {
        // so we can bootstrap admins on local/debug
        if (process.env.NODE_ENV !== 'development') {
            this.setFieldState('ischarity', event.target.checked ? '' : 'required');
        }
    }

    render() {
        const { children } = this.props;
        const { fieldIsValids } = this.state;

        const formError = children.find((c) => getValidationSummary(c));

        const controls = flattenChildren(children)
            .filter((c) => isType(c, 'ControlP'))
            .map((c) => this.getControl(c));

        const invalid = Object.values(fieldIsValids).filter((c) => !c).length > 0;

        return (
            <div className="layout-spacing-bottom">
                <SubmitForm
                    buttonLabel="Create an account"
                    name="create-account"
                    isActionsCentered
                    isInvalid={invalid}
                >
                    {formError}
                    {controls}
                </SubmitForm>
            </div>
        );
    }
}

AccountSignupForm.propTypes = {
    children: PropTypes.node.isRequired,
};

export default AccountSignupForm;
